"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ChainsAbstract_1 = require("../ChainsAbstract");
const types_1 = require("@requestnetwork/types");
const index_1 = require("./index");
class NearChains extends ChainsAbstract_1.ChainsAbstract {
}
exports.default = new NearChains(index_1.chains, types_1.RequestLogicTypes.CURRENCY.ETH);
